angular.module('impactx.productcoding').controller('ProductCodingNestedTreeListCtrl', [ProductCodingNestedTreeListCtrl]);

function ProductCodingNestedTreeListCtrl() {
    var self = this;
    self.entryLimit = 50;

    self.expandSub = function (event, entry) {
        if (entry.isLeaf) {
            event.stopPropagation();
            event.preventDefault();
        }
        else {
            self.expand({event: event, entry: entry});
        }
    };

    self.increaseEntryLimit = function (event) {
        event.stopPropagation();
        event.preventDefault();
        self.entryLimit = self.entryLimit + 50;
    }

    self.editSub = function (event, entry) {
        self.editEntry({event: event, entry: entry});
    };

    self.addSub = function (event, entry) {
        self.addEntries({event: event, entry: entry});
    };

    self.getIconClass = function (entry) {
        var result = '';

        switch (entry.type) {
            case "VCATALOG":
                result += (entry.coding ? 'mdi-icon-green' : 'mdi-icon-dark-grey') + ' mdi-book';
                break;
            case "PRG":
                result += (entry.coding ? 'mdi-icon-green' : 'mdi-icon-dark-grey') + ' mdi-folder';
                break;
            case "PRO":
                result += (entry.coding ? 'mdi-icon-green' : 'mdi-icon-dark-grey') + ' mdi-cog';
                break;
            default:
                return "";
        }


        return result;
    }
}